module.exports = __webpack_public_path__ + "img/microsoft-new.12a7f8be.png";